/* eslint-disable no-useless-escape */

//
// Client utilities
//
import {
  checkAxiosData,
  checkIsJSON,
  convertQueryObjToString,
  getAxiosErr,
  MAINTAIN_KEY
} from 'fe-common'

import { catchError, empty, filter, from, tap } from 'rxjs'

import dayjs from '../../plugins/dayjs'

const DEBUG_MODE = false

export const REQUEST_TIMEOUT = 5000 // sec

export const POSTCODE_TO_CITIES = [
  {
    postcodes: ['00', '04', '05', '06', '07', '08', '09'],
    city: '北海道'
  },
  {
    postcodes: ['03'],
    city: '青森県'
  },
  {
    postcodes: ['02'],
    city: '岩手県'
  },
  {
    postcodes: ['98'],
    city: '宮城県'
  },
  {
    postcodes: ['01'],
    city: '秋田県'
  },
  {
    postcodes: ['99'],
    city: '山形県'
  },
  {
    postcodes: ['96', '97'],
    city: '福島県'
  },
  {
    postcodes: ['30', '31'],
    city: '茨城県'
  },
  {
    postcodes: ['32'],
    city: '栃木県'
  },
  {
    postcodes: ['37'],
    city: '群馬県'
  },
  {
    postcodes: ['33', '34', '35', '36'],
    city: '埼玉県'
  },
  {
    postcodes: ['26', '27', '28', '29'],
    city: '千葉県'
  },
  {
    postcodes: [
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20'
    ],
    city: '東京都'
  },
  {
    postcodes: ['21', '22', '23', '24', '25'],
    city: '神奈川県'
  },
  {
    postcodes: ['94', '95'],
    city: '新潟県'
  },
  {
    postcodes: ['93'],
    city: '富山県'
  },
  {
    postcodes: ['92'],
    city: '石川県'
  },
  {
    postcodes: ['91'],
    city: '福井県'
  },
  {
    postcodes: ['40'],
    city: '山梨県'
  },
  {
    postcodes: ['38', '39'],
    city: '長野県'
  },
  {
    postcodes: ['50'],
    city: '岐阜県'
  },
  {
    postcodes: ['41', '42', '43'],
    city: '静岡県'
  },
  {
    postcodes: ['44', '45', '46', '47', '48', '49'],
    city: '愛知県'
  },
  {
    postcodes: ['51'],
    city: '三重県'
  },
  {
    postcodes: ['52'],
    city: '滋賀県'
  },
  {
    postcodes: ['60', '61', '62'],
    city: '京都府'
  },
  {
    postcodes: ['53', '54', '55', '56', '57', '58', '59'],
    city: '大阪府'
  },
  {
    postcodes: ['65', '66', '67'],
    city: '兵庫県'
  },
  {
    postcodes: ['63'],
    city: '奈良県'
  },
  {
    postcodes: ['64'],
    city: '和歌山県'
  },
  {
    postcodes: ['68'],
    city: '鳥取県'
  },
  {
    postcodes: ['69'],
    city: '島根県'
  },
  {
    postcodes: ['70', '71'],
    city: '岡山県'
  },
  {
    postcodes: ['72', '73'],
    city: '広島県'
  },
  {
    postcodes: ['74', '75'],
    city: '山口県'
  },
  {
    postcodes: ['77'],
    city: '徳島県'
  },
  {
    postcodes: ['76'],
    city: '香川県'
  },
  {
    postcodes: ['79'],
    city: '愛媛県'
  },
  {
    postcodes: ['78'],
    city: '高知県'
  },
  {
    postcodes: ['80', '81', '82', '83'],
    city: '福岡県'
  },
  {
    postcodes: ['84'],
    city: '佐賀県'
  },
  {
    postcodes: ['85'],
    city: '長崎県'
  },
  {
    postcodes: ['86'],
    city: '熊本県'
  },
  {
    postcodes: ['87'],
    city: '大分県'
  },
  {
    postcodes: ['88'],
    city: '宮崎県'
  },
  {
    postcodes: ['89'],
    city: '鹿児島県'
  },
  {
    postcodes: ['90'],
    city: '沖縄県'
  }
]

export function refreshToken({ rootState, dispatch, commit, $dayjs }) {
  const _dayjs = $dayjs || dayjs
  const currentTokenExp = rootState.authModule.tokenExp
  const currentTokenExpDate = _dayjs(currentTokenExp * 1000)
  const nowDate = _dayjs()
  // console.log('currentTokenExpDate:', currentTokenExpDate)
  // console.log('nowDate:', nowDate)
  // console.log('diff:', currentTokenExpDate.diff(nowDate, 'minutes'))
  if (
    currentTokenExpDate.isAfter(nowDate) &&
    currentTokenExpDate.diff(nowDate, 'minutes') < 10
  ) {
    return immediateRefreshToken({ dispatch, commit })
  }
  return Promise.resolve()
}

export function immediateRefreshToken(store) {
  return immediateRefreshToken$(store).toPromise()
}

export function immediateRefreshToken$(store) {
  const { dispatch, commit } = store
  return from(dispatch('authModule/refreshToken', null, { root: true })).pipe(
    filter(data =>
      checkAxiosData(data, {
        handleMessages: handleMessages({ store })
      })
    ),
    tap(({ result }) => {
      commit('authModule/TOKEN', result.token, {
        root: true
      })
      commit('authModule/TOKEN_EXP', result.exp, {
        root: true
      })
      commit('authModule/USER', result.user, { root: true })
    })
  )
}

export function refreshUser(store, payload) {
  return refreshUser$(store, payload).toPromise()
}

export function refreshUser$({ dispatch, commit }, payload = { token: null }) {
  return from(dispatch('authModule/getUser', payload, { root: true }))
}

// Vue Component Example:
//
/*
  mounted() {
    wrapped(document.querySelectorAll('.js-list'))
  }
 */
export function wrapped(ul) {
  for (let i = 0; i < ul.length; i++) {
    // Children gets all the list items as another HTML Collection
    const li = ul[i].children

    let originOffsetTop = 0
    for (let j = 0; j < li.length; j++) {
      // offsetTop will get the vertical distance of the li from the ul.
      const loc = li[j].offsetTop
      if (originOffsetTop === 0) {
        li[j].classList.add('wrapped')
        originOffsetTop = loc
      } else {
        if (loc > originOffsetTop) {
          li[j].classList.add('wrapped')
        } else {
          li[j].classList.add('unwrapped')
        }
        originOffsetTop = loc
      }
    }
  }
}

export function getDeviceId() {
  // eslint-disable-next-line no-undef
  const fpPromise = FingerprintJS.load()
  return (
    fpPromise
      .then(fp => fp.get())
      // .then(result => {
      //   console.log('visitorId:', result.visitorId)
      //   return result
      // })
      .then(result => result.visitorId)
      .catch(err => console.error(err))
  )
}

/**
 * https://dev.fingerprint.com/docs/migrating-from-open-source-v3
 *
 * @param apiKey: Sign up on (dashboard.fingerprint.com/signup)[https://dashboard.fingerprint.com/signup], create a account, then get a public API key.
 * @returns {*}
 */
export function getDeviceIdByPro(apiKey) {
  // eslint-disable-next-line no-undef
  const fpPromise = FingerprintJSPro.load({ apiKey })
  return (
    fpPromise
      .then(fp => fp.get())
      // .then(result => {
      //   console.log('visitorId:', result.visitorId)
      //   return result
      // })
      .then(result => result.visitorId) // That's it, the visitorId has pro-level accuracy of 99.5% now.
      .catch(err => console.error(err))
  )
}
export function getDiffUTCTimeFromNow(utcExpTime, dayjs) {
  const _this = this || {}
  const nowTime = (_this.$dayjs || dayjs).utc()
  const expTime = (_this.$dayjs || dayjs).utc(utcExpTime)
  const days = expTime.diff(nowTime, 'days')
  const hours = expTime.subtract(days, 'days').diff(nowTime, 'hours')
  const minutes = expTime
    .subtract(days, 'days')
    .subtract(hours, 'hours')
    .diff(nowTime, 'minutes')
  const seconds = expTime
    .subtract(days, 'days')
    .subtract(hours, 'hours')
    .subtract(minutes, 'minutes')
    .diff(nowTime, 'seconds')
  return {
    days,
    hours,
    minutes,
    seconds
  }
}

export function getCookieScope(req) {
  let scope = {}
  if (process.env.COOKIE_SCOPE === 'DOMAIN') {
    const hostnameSplits = req.hostname.split('.')
    scope = {
      domain: `.${hostnameSplits[hostnameSplits.length - 2]}.${
        hostnameSplits[hostnameSplits.length - 1]
      }`
    }
  }
  return scope
}

/**
 * 移除尾綴的路徑並回傳
 *
 * @param route: vue route
 * @returns {string}: path
 */
export function removeSuffixPath(route) {
  const paths = route.path.split('/')
  paths.pop()
  return (
    (paths.join('/') ? paths.join('/') : '/') +
    (route.query && Object.keys(route.query).length > 0
      ? `?${convertQueryObjToString(route.query)}`
      : '')
  )
}

/**
 *
 * @param err
 * @param context : nuxt context api
 */
export function serverErrorHandler(err, context) {
  const axiosErr = getAxiosErr(err)
  const { statusCode, message } = axiosErr
  let { maintainProperties } = axiosErr

  const { store, route, redirect, error, $dayjs } = context

  // csrf error handler
  // if (statusCode === 403 && message === 'Invalid CSRF Token') {
  //   // this stage will not happen
  // }

  // auth error handler
  if (statusCode === 401) {
    const logoutAfter = () => {
      store.commit('authModule/TOKEN', null)
      store.commit('authModule/TOKEN_EXP', null)
      setTimeout(() => {
        store.commit('authModule/USER', null)
      }, 0)
      try {
        redirect(
          `/?openLoginModal=true&target=${
            route.hasOwnProperty('value') ? route.value.path : route.path // for composition api ref use
          }&time=${new Date().getTime()}`
        )
      } catch (e) {
        if (
          e.message?.indexOf(
            'Cannot set headers after they are sent to the client'
          ) === -1
        )
          throw e
      }
    }
    from(store.dispatch('authModule/logout'))
      .pipe(
        filter(
          data =>
            !data ||
            checkAxiosData(data, { handleMessages: handleMessages(context) })
        ),
        tap(() => logoutAfter()),
        catchError(err => {
          const { statusCode } = getAxiosErr(err)
          if (statusCode === 401) {
            logoutAfter()
          } else {
            serverErrorHandler(err, context)
          }
          return empty()
        })
      )
      .subscribe()
    return
  }

  // CDN handler
  // if (contentType && contentType.indexOf('application/json') === -1) {
  //   // handled by error page
  // }

  // webapi GG handler
  if (
    statusCode === 500 &&
    message &&
    (message === `timeout of ${REQUEST_TIMEOUT}ms exceeded` ||
      message.startsWith('connect ECONNREFUSED') ||
      message.startsWith('read ECONNRESET'))
  ) {
    error({
      statusCode: 503,
      message: ''
    })
    return
  }

  // maintain handler
  if (statusCode === 503 && maintainProperties) {
    if (process.server) {
      maintainProperties = require('buffer')
        .Buffer.from(maintainProperties, 'base64')
        .toString()
    } else {
      maintainProperties = atob(maintainProperties)
    }
    if (checkIsJSON(maintainProperties)) {
      maintainProperties = JSON.parse(maintainProperties)
      const maintainStartTime = $dayjs
        .utc(maintainProperties.startTime)
        .tz()
        .format('HH:mm')
      const maintainEndTime = $dayjs
        .utc(maintainProperties.endTime)
        .tz()
        .format('HH:mm')
      error({
        statusCode: 599,
        maintainStartTime,
        maintainEndTime,
        message: ''
      })
      return
    }
  }

  error(axiosErr)
}

/**
 *
 * @param context: nuxt context
 * @returns {function(*): boolean}
 */
export const handleMessages = context => messages => {
  const { store } = context
  const { commit } = store
  commit('GLOBAL_MESSAGE', null, {
    root: true
  })

  // maintain handler
  const maintainProperties = messages.find(message =>
    message.startsWith(MAINTAIN_KEY)
  )
  if (maintainProperties) {
    commit(
      'GLOBAL_MESSAGE',
      {
        type: 'MAINTAIN',
        style: 'warning',
        message: '',
        data: {
          startTime: maintainProperties.split('::')[1],
          endTime: maintainProperties.split('::')[2]
        }
      },
      {
        root: true
      }
    )
  }

  // other...

  return true
}

/**
 *
 * @param num
 * @param digits: 處理到小數點後幾位數， default: 6
 * @param type: 'round'| 'floor'| 'ceil'， default: 'round'
 * @returns {string}
 */
export function currency(num, digits = 6, type = 'round') {
  const n = Number(num)
  let resultStr = String(n)

  // return original string if num is String
  if (isNaN(num)) {
    return num
  }

  // check if n is float
  if (n !== parseInt(resultStr)) {
    const base = Math.pow(10, digits)

    switch (type) {
      case 'floor':
        resultStr = String(Math.floor(n * base) / base)
        break
      case 'ceil':
        resultStr = String(Math.ceil(n * base) / base)
        break
      case 'round':
      default:
        if (digits === 0) {
          resultStr = String(Math.round(parseFloat(n.toFixed(2))))
        } else {
          resultStr = String(parseFloat(n.toFixed(digits)))
        }
        break
    }
  }

  // 處理負數
  let minus = ''
  if (resultStr.startsWith('-')) {
    minus = '-'
    resultStr = resultStr.slice(1)
  }

  const iterateChar = (char, idx, wholeStr) => {
    if (wholeStr.indexOf('.') !== -1 && wholeStr.indexOf('.') < idx) {
      return char
    }
    const integerLength = wholeStr.split('.')[0].length
    const hasPrefixComma = (integerLength - idx) % 3 === 0
    return idx > 0 && char !== '.' && hasPrefixComma ? `,${char}` : char
  }

  return `${minus}${resultStr.replace(/./g, iterateChar)}`
}

export function toPercent(ratio) {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(ratio)
}

export function getCreditCardType(cardNumber) {
  let type = null
  const creditCardTypes = {
    mastercard: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    JCB: /^(?:2131|1800|35\d{3})\d{11}$/,
    VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
    AMEX: /^3[47][0-9]{13}$/,
    DINERS: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/
  }

  Object.keys(creditCardTypes).forEach(creditCardType => {
    if (new RegExp(creditCardTypes[creditCardType]).test(cardNumber)) {
      type = creditCardType
    }
  })

  return type
}

// base64 string to File
export function convertDataURLtoFile(dataUrl, filename) {
  if (!dataUrl) {
    return
  }

  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const ext = mime.split('/')[1]
  const bString = atob(arr[1])
  let n = bString.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bString.charCodeAt(n)
  }
  return {
    file: new File([u8arr], `${filename}.${ext}`, { type: mime }),
    fileName: `${filename}.${ext}`
  }
}

/**
 * 是否特定的時間在某個區間時間上 (須提供 UTC 時間)
 *
 * @param startTimeStr format: 'HH:mm:ss'
 * @param endTimeStr format: 'HH:mm:ss'
 * @param targetTime: dayjs instance, default is now (utc)
 * @returns {boolean}
 */
export function isIncludeUTCTime(
  startTimeStr,
  endTimeStr,
  targetTime = dayjs.utc()
) {
  if (!dayjs.isDayjs(targetTime)) {
    throw new Error('The targetTime must be dayjs instance.')
  }
  if (!(targetTime.hasOwnProperty('isUTC') && targetTime.isUTC())) {
    console.warn(
      `The targetTime will be automatically converted to UTC format, original: ${targetTime.format(
        'HH:mm:ss'
      )}, new: ${targetTime.utc().format('HH:mm:ss')}`
    )
    targetTime = targetTime.utc()
  }
  const startDateTime = dayjs.utc(`${startTimeStr}`, 'HH:mm:ssZ')
  const endDateTime = dayjs.utc(`${endTimeStr}`, 'HH:mm:ssZ')

  targetTime = targetTime
    .year(startDateTime.year())
    .month(startDateTime.month())
    .day(startDateTime.day())

  const targetTimeToStartTimeDurationHours = dayjs
    .duration(targetTime.diff(startDateTime))
    .asHours()
  const endTimeToStartTimeDurationHours = dayjs
    .duration(endDateTime.diff(startDateTime))
    .asHours()

  if (DEBUG_MODE) {
    console.log('== isIncludeUTCTime ==')
    console.log(
      'startDateTime:',
      startDateTime.format('YYYY-MM-DD HH:mm:ss'),
      `, config: ${targetTime.format('YYYY-MM-DD')} ${startTimeStr}`
    )
    console.log(
      'endDateTime:',
      endDateTime.format('YYYY-MM-DD HH:mm:ss'),
      `, config: ${targetTime.format('YYYY-MM-DD')} ${endTimeStr}`
    )
    console.log('targetTime:', targetTime.format('YYYY-MM-DD HH:mm:ss'))
    console.log(
      'targetTimeToStartTimeDurationHours:',
      targetTimeToStartTimeDurationHours
    )
    console.log(
      'endTimeToStartTimeDurationHours:',
      endTimeToStartTimeDurationHours
    )
    console.log('== isIncludeUTCTime ==')
  }

  return (
    parseFloat(targetTimeToStartTimeDurationHours) >= parseFloat(0) &&
    parseFloat(targetTimeToStartTimeDurationHours) <=
      parseFloat(endTimeToStartTimeDurationHours)
  )
}

/**
 * 是否特定的時間在某個區間時間上
 *
 * @param startTimeStr format: 'HH:mm:ss+8' or 'HH:mm:ss+08' or 'HH:mm:ss+08:00' or 'HH:mm:ss+0800'
 * @param endTimeStr format: 'HH:mm:ss+8' or 'HH:mm:ss+08' or 'HH:mm:ss+08:00' or 'HH:mm:ss+0800'
 * @param targetTime: dayjs instance, default is now (utc)
 */
export function isIncludeTime(startTimeStr, endTimeStr, targetTime) {
  return isIncludeUTCTime(
    formatOffset(startTimeStr),
    formatOffset(endTimeStr),
    targetTime
  )
}

export function formatOffset(timeStr) {
  if (!timeStr.includes('+') && !timeStr.includes('-')) return timeStr
  const sign = timeStr.indexOf('+') > 0 ? '+' : '-'
  const time = timeStr.split(sign)[0]
  let offset = timeStr.split(sign)[1]
  if (offset.length === 1) {
    offset = sign + '0' + offset + ':00'
  } else if (offset.length === 2) {
    offset = sign + offset + ':00'
  } else if (offset.indexOf(':') > 0) {
    if (offset.indexOf(':') === 1 && offset.length === 4) {
      offset = sign + '0' + offset
    } else if (offset.indexOf(':') === 2 && offset.length === 5) {
      offset = sign + offset
    } else {
      offset = ''
    }
  } else if (offset.length === 3) {
    offset = sign + '0' + offset.substring(0, 1) + ':' + offset.substring(1)
  } else if (offset.length === 4) {
    offset = sign + offset.substring(0, 2) + ':' + offset.substring(2)
  } else {
    offset = ''
  }
  return time + offset
}

export function isIncludeKeyVals(obj, fields) {
  return obj && Object.keys(fields).every(key => obj[key] === fields[key])
}

export function amountStr2Arr(str = '') {
  return str
    .split(';')
    .filter(amountStr => amountStr)
    .map(amountStr => parseFloat(amountStr))
}

const utilities = {
  refreshToken,
  getDiffUTCTimeFromNow,
  getCookieScope,
  removeSuffixPath,
  serverErrorHandler,
  handleMessages,
  currency,
  toPercent,
  getCreditCardType,
  convertDataURLtoFile,
  isIncludeUTCTime,
  isIncludeTime,
  formatOffset,
  isIncludeKeyVals,
  amountStr2Arr
}

export default utilities
